const axios = require('axios');
const RatingWidget = require('./classes/RatingWidget');

// IE-friendly forEach iteration...
$('.star-rating').each((_, el) => new RatingWidget(el));

$(document).on('submit', '.js-comment-form', function (e) {
	e.preventDefault();

	let form = $(this);
	let btns = form.find(':button');

	// Disable the buttons.
	btns.prop('disabled', true);

	axios.post(this.action, {
		body: form.find('textarea[name=body]').val()
	})
		.then(response => {
			btns.prop('disabled', false);

			if (response && response.status === 200) {
				// Reset the form.
				form.get(0).reset();

				// Add the new comment.
				$('.idea-comments').append(response.data);
			}
		})
		.catch(error => {
			console.error(error);
			btns.prop('disabled', false);
		});
});

$(document).on('click', '#subscription', function () {
	const me = $(this),
		input = me.find(':checkbox:first'),
		url = me.data('api'),
		states = {
			true: 'subscribe',
			false: 'unsubscribe'
		};

	axios.get(url.replace(':state', states[input.prop('checked')]));
});

$(document).on('click', '#attachments-list .js-delete-attachment', function (e) {
	e.preventDefault();

	if (confirm('Are you sure you wish to delete this attachment?')) {
		axios.delete(this.href)
			.then(r => {
				if (r.data.success) {
					$(this).closest('.attachment').remove();

					const $list = $('#attachments-list');

					if ($list.children().length === 0) {
						$list.append('<p class="text-muted">This idea has no attachments.</p>');
					}
				} else {
					console.error('failed deleting attachment; got', r);
				}
			});
	}
});

$(function ($) {
	let m_editable = $('#makeEditable');

	m_editable.on('submit', 'form', () => {
		m_editable.find('button').prop('disabled', true);
	});

	m_editable.on('hidden.bs.modal', () => {
		m_editable.find('button').prop('disabled', false);
	});
});